import React from 'react';
import { connect } from 'react-redux';
import { Button, Table } from 'semantic-ui-react';
import { concat, each } from 'lodash';
import PhotoBoothModal from '../../../../../../../containers/PhotoBoothModal';
import { closeAllModals } from '../../../data/fileImport/modalActions';

class SessionQuality extends React.Component {
  render() {
    if (!this.props.session) return false;

    let tableHeader1 = (
      <Table.HeaderCell className="th_session-name" key={1}>
        Session
      </Table.HeaderCell>
    );
    let tableHeader2 = <Table.HeaderCell key={2}></Table.HeaderCell>;
    let tableBody = <Table.Cell key={3}> {this.props.session.name} </Table.Cell>;

    each(this.props.session.files, (file, f_i) => {
      tableHeader1 = concat(
        tableHeader1,
        <Table.HeaderCell key={`file_${f_i}`} colSpan={file.abstract_types.length * 2}>
          <span className="file-number"> File {f_i + 1} </span>
          <br />
          <span className="file-name"> test.txt {file.name}</span>
        </Table.HeaderCell>
      );
      tableHeader2 = concat(
        tableHeader2,
        file.metrics.map((metric, m_i) => {
          return (
            <Table.HeaderCell key={`metric_${f_i}_${m_i}`} colSpan={2}>
              <span className="labelMetric--name"> {metric.name} </span>
              <br />
              <span className="labelMetric--quality">Quality</span>
              <span className="labelMetric--sync-time"> Sync </span>
            </Table.HeaderCell>
          );
        })
      );
      tableBody = concat(
        tableBody,
        file.metrics.map((metric, m_i) => {
          return [
            <Table.Cell key={`ms1_${f_i}_${m_i}`}>
              <span className="metricQuality bad">{metric.dataQuality} 45%</span>
            </Table.Cell>,
            <Table.Cell key={`ms2_${f_i}_${m_i}`}>
              <span className="metricSyncTime good">{metric.syncTime} 100sm</span>
            </Table.Cell>
          ];
        })
      );
    });

    return (
      <PhotoBoothModal {...this.props}>
        <div className="sessionQuality__container">
          <h3 className="modal-title">Quality</h3>
          <div className="sessionQuality__table-container">
            <Table celled className="sessionQuality__table table striped">
              <Table.Header>
                <Table.Row>{tableHeader1}</Table.Row>
                <Table.Row key="header_2">{tableHeader2}</Table.Row>
              </Table.Header>
              <Table.Body>
                <Table.Row>{tableBody}</Table.Row>
              </Table.Body>
            </Table>
          </div>
          <div className="submit-btn-container">
            <Button
              className="green right floated"
              type="button"
              onClick={event => this.props.dispatch(closeAllModals())}
            >
              <i className="check square outline icon" /> OK
            </Button>
          </div>
        </div>
      </PhotoBoothModal>
    );
  }
}

export default connect(state => ({
  session: state.projects.single.fileImport.sessions.find(
    session => session.id === state.projects.single.fileImport.modals.qualitySession.dataTreeId
  )
}))(SessionQuality);



// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/components/fileImport/modals/SessionQuality.js